import React, { useState } from 'react';
import Header from '../../components/header';
import NotificationTools from '../../components/notificationTools';
import TimezoneInfo from '../../components/timezoneInfo';
import ReloadButton from '../../components/reloadButton';
import SitesContainer from '../../containers/sites';
import ProjectSelector from '../../components/projectSelector';

const SitesScreen = () => {
  const [lastUpdated, setLastUpdated] = useState('');

  return (
    <div className="d-flex flex-column flex-fill">
      <Header
        title={'Management'}
        icon={'settingsDark'}
        filters={<ProjectSelector/>}
        actions={[
          { type: 'reactComponent', value: <TimezoneInfo key="timezone-info" /> },
          {
            type: 'reactComponent',
            value: <ReloadButton key="reload-btn" contentName="Sites list" lastUpdatedCB={setLastUpdated} />
          },
          { type: 'reactComponent', value: <NotificationTools key="notification-btn" /> }
        ]}
      />
      <SitesContainer lastUpdated={lastUpdated} />
    </div>
  );
};

export default SitesScreen;
